import styled from 'styled-components';

export const VideoPlayButtonStyled = styled.button`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background: none;
    border: none;
    min-height: 96px;
    min-width: 96px;
`;

export const VideoPlayButtonInnerCircleStyled = styled.div`
    @keyframes pulse {
        0% {
            box-shadow: 0 0 0 0 #FFDD3C66;
        }

        65% {
            box-shadow: 0 0 0 16px #FFDD3C66;
        }

        100% {
            box-shadow: 0 0 0 0 #FFDD3C66;
        }
    }
    
    background: var(--color-yellow);
    border-radius: 100px;
    padding: 20px;
    animation: pulse 1.6s infinite;
    transition: padding 1000ms linear;
    
    &.hover {
        padding: 26px;
        animation: none;
    }
`;
